// import { parseVueRouterLink, params } from '@hb/utils-monorepo/url';
import MainStore from '@/store/userStore';
import params from '../param';
import BrowserCallNative from './BrowserCallNative.js';

export default class AliTripCallNative extends BrowserCallNative {
  static callNative(name, data) {
    if (!this[name]) {
      return Promise.reject(new Error(`${name}功能在支付宝中暂时无法使用`));
    }
    return this[name](data);
  }

  static miniPay(paymentInfo) {
    return new Promise((resolve, reject) => {
      window.methodChannel.call('minipay', { order_info: paymentInfo }, resolve, reject);
    });
  }

  static closeWebView() {
    return window.methodChannel.call('close', { data: {} });
  }

  static getTokenAndKey() {
    const locationHref = window.location.href;
    const {
      hashParams: { token, ticket, userGuid } = {},
    } = params.parseVueRouterLink(locationHref) || {};
    // eslint-disable-next-line no-console
    console.warn('AliTrip', token, ticket, userGuid);
    if (token) {
      const userInfo = {
        token,
        ticket: ticket || '',
        userGuid: userGuid || '',
      };
      MainStore.setUserInfo(userInfo);
      return Promise.resolve(userInfo);
    }
    const res = MainStore.getUserStore() || {};
    return Promise.resolve({ ...res });
  }

  static setWebViewTitle(info) {
    return window.methodChannel.call('set_webview_title', { title: info.title, subtitle: info.subtitle, image: info.image });
  }
}
